import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * Validation error row. Use `reserve` on side-by-side fields so columns
 * stay aligned when an error appears in one column only.
 */
export default function FormFieldError({
  message,
  reserve = true,
  className = "",
}) {
  const minHeight =
    className.includes("min-h-") || !reserve ? "" : "min-h-[18px]";

  return (
    <p
      className={`text-[12px] text-red-600 mt-0.5 flex items-start gap-0.5 leading-snug ${minHeight} ${className}`}
      role={message ? "alert" : undefined}
      aria-live={message ? "polite" : undefined}
    >
      {message ? (
        <>
          <AlertCircle size={12} className="shrink-0 mt-px" />
          <span>{message}</span>
        </>
      ) : (
        <span className="sr-only">No error</span>
      )}
    </p>
  );
}
